import journeyActionsList from './journeyActionsList.json';
import announcementsActionsList from './announcementsActionsList.json';

import actions from './actions';

const badgeTypes = {
  tip: 1,
  badge: 2,
  badgeAndTip: 3,
  announcement: 4,
};

export default {
  namespaced: false,
  state: {
    journeyActionsList,
    announcementsActionsList,
    badgeTypes,
  },
  actions,
};
